import React from 'react';

import { IPohodnikRouterItem } from '.';

const RadishPage = React.lazy(() => import('@apps/Hiking/radish/RadishPage'));
const RadishOnePage = React.lazy(() => import('@apps/Hiking/radish/RadishOnePage'));

const radishRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/radish',
    component: () => <RadishPage />,
    title: 'Список редисок',
  },

  {
    path: '/radish/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <RadishOnePage id_user={+id} />,
    title: 'Страница редиски',
  },
];

export default radishRoutes;
